import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import LandingPage from './LandingPage'

/**
 * Route component for `/` inside the authenticated-app shell (i.e. once
 * AppBootstrap has resolved — the pow_returning hint was present). Keeps the
 * authenticated-redirect check here, deliberately: LandingPage itself must stay
 * backend-independent (it also renders standalone, pre-gate, via LandingGate),
 * so the auth-aware check can't live inside it. See
 * docs/decisions/2026-08-04-pow-returning-flag.md.
 */
export default function LoginPage() {
  const { status, fetchUser } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (status === 'unknown') {
      fetchUser()
    } else if (status === 'authenticated') {
      navigate('/home', { replace: true })
    }
  }, [status, fetchUser, navigate])

  // Hold a neutral surface until auth resolves. Rendering LandingPage while
  // fetchUser() is still in flight flashed the marketing page at every returning
  // authenticated visitor before redirecting them to /home. Visitors arriving
  // here from ProtectedRoute already have status 'unauthenticated', so they fall
  // straight through to LandingPage with no extra blank moment.
  if (status !== 'unauthenticated') {
    return <div className="min-h-screen bg-brand-surface" aria-hidden="true" />
  }

  return <LandingPage />
}
